import {
  dateOrDateTimeFormatter,
  eventFormatter,
  dateTimeFormatter,
  sessionNumberFormatter,
  clientIdFormatter,
  readableEventDescription,
} from '../../utils/formatters';

export const eventLogColumns = [
  {
    dataField: 'created_at',
    text: 'Дата и время',
    disableSort: true,
    dataClassName: 'align-middle',
    formatter: date => dateOrDateTimeFormatter(date),
    toCopyFormatter: dateTimeFormatter,
    headerClassName: 'date-time-column',
    hidden: true,
    disablePosition: false,
  },
  {
    dataField: 'description',
    text: 'Событие',
    disableSort: true,
    formatter: eventFormatter,
    toCopyFormatter: readableEventDescription,
    hidden: true,
    disablePosition: false,
    headerClassName: 'description-column',
  },
];

export const addEventLogColumns = [
  {
    dataField: 'client_id',
    text: 'ИД клиента',
    disableSort: true,
    dataClassName: 'align-middle',
    hidden: true,
    disablePosition: false,
    headerClassName: 'id-column',
    formatter: clientIdFormatter,
  },
  {
    dataField: 'session_id',
    text: 'Номер сессии',
    disableSort: true,
    dataClassName: 'align-middle',
    headerClassName: 'id-column',
    // formatter: e => e.id,
    formatter: sessionNumberFormatter,
    hidden: true,
    disablePosition: false,
  },
];
